<mat-form-field class="example-chip-list itb-multiselect-chip" [ngClass]="{'itb-multiselect-required':isRequired}">
  <mat-chip-list #chipList aria-label="Fruit selection">
    <ng-container *ngIf="!isDisabled">
    <mat-chip  *ngFor="let tags of tags" [removable]="removable" (removed)="remove(tags)">
      {{ tags }}
      <!-- <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon> -->
      <span matChipRemove *ngIf="removable" class="chip-btn"><itb-icon [className]="'cross icon-disabled'" ></itb-icon></span>
    </mat-chip>
  </ng-container>
  <ng-container *ngIf="isDisabled">
    <mat-chip  *ngFor="let tags of tags" [removable]="removable" (click)="onViewChipClick(tags)">
      {{ tags }}
      <!-- <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon> -->
      <!-- <span matChipRemove *ngIf="removable" class="chip-btn"><itb-icon [className]="'cross icon-disabled'" ></itb-icon></span> -->
    </mat-chip>
  </ng-container>
    <input [readonly]="isReadOnly" #trigger="matAutocompleteTrigger" [required]="isRequired" [disabled]="isDisabled" [placeholder]="placeholder" #tagsInput [formControl]="dataCtrl" [matAutocomplete]="auto"
      [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="add($event)" (keypress)="restrictEvent($event)" />
  </mat-chip-list>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)" #autoCompletePageList>
    <mat-option *ngFor="let tags of filteredData | async" [value]="tags" (click)="$event.stopPropagation(); trigger.openPanel()">
      {{ tags }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
<itb-info-message *ngIf="errorFlag" [className]="'info-danger'" [text]="'Maximum '+tagsMaxLength+' tags allowed'"></itb-info-message>
<itb-info-message [className]="'info-danger'" [text]="duplicationMessage"></itb-info-message>